"use client";

import { toast } from "sonner";
import { ResetPasswordForm } from "../forms/reset-password-form";

export function ResetPasswordView() {
  const handleSuccess = () => {
    toast.success("Link de redefinição enviado! Verifique seu e-mail.");
  };

  const handleError = (error: any) => {
    const errorMessage = Array.isArray(error?.message) ? error.message[0] : error?.message;
    toast.error(errorMessage || "Erro ao enviar link de redefinição.");
  };

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        <ResetPasswordForm onSuccess={handleSuccess} onError={handleError} />
      </div>
    </div>
  );
}
